import React from 'react';
import { Search } from 'lucide-react';

const SELECTS = [
  { k: 'status', all: 'All Status', opt: 'statuses' },
  { k: 'user_type', all: 'All User Types', opt: 'user_types' },
  { k: 'send_type', all: 'All Send Types', opt: 'send_types' },
  { k: 'domain_type', all: 'All Domain Types', opt: 'domain_types' },
];
const TEXTS = [
  { k: 'lms_id', ph: 'LMS ID' },
  { k: 'domain', ph: 'Domain' },
  { k: 'email', ph: 'Email', pii: true },
];

function Select({ k, all, options, value, onChange }) {
  return (
    <select className="filter-select" value={value || ''} onChange={e => onChange(k, e.target.value)} data-testid={`voucher-filter-${k}`}>
      <option value="">{all}</option>
      {(options || []).map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

export function VoucherFilters({ options, filters, onChange, onClear, perPage, onPerPage, piiAllowed }) {
  return (
    <div className="filter-bar" data-testid="voucher-filters" style={{ flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
      <select className="filter-select" style={{ minWidth: 280, fontWeight: 600 }} value={filters.campaign || ''}
        onChange={e => onChange('campaign', e.target.value)} data-testid="voucher-filter-campaign">
        <option value="">All Campaigns</option>
        {(options.campaigns || []).map(o => <option key={o} value={o}>{o}</option>)}
      </select>
      {SELECTS.map(s => <Select key={s.k} {...s} options={options[s.opt]} value={filters[s.k]} onChange={onChange} />)}
      {TEXTS.filter(t => !t.pii || piiAllowed).map(t => (
        <input key={t.k} className="filter-input" placeholder={t.ph} value={filters[t.k] || ''}
          onChange={e => onChange(t.k, e.target.value)} data-testid={`voucher-filter-${t.k}`} style={{ width: 150 }} />
      ))}
      <Select k="voucher_type" all="All Voucher Types" options={options.voucher_types} value={filters.voucher_type} onChange={onChange} />
      <div style={{ position: 'relative' }}>
        <Search size={14} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
        <input className="filter-input" placeholder="Filter by Course…" value={filters.course || ''} style={{ paddingLeft: 30, width: 200 }}
          onChange={e => onChange('course', e.target.value)} data-testid="voucher-filter-course" />
      </div>
      <button className="btn btn-secondary" onClick={onClear} data-testid="voucher-clear-filters" style={{ padding: '6px 12px', fontSize: 13 }}>Clear filters</button>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#475569' }}>
        Show
        <select className="filter-select" value={perPage} onChange={e => onPerPage(Number(e.target.value))} data-testid="voucher-per-page" style={{ minWidth: 70 }}>
          {[25, 50, 100, 250].map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        entries
      </div>
    </div>
  );
}
